import { AcuityCategory } from './acuity-category.model';
import { RoomType } from './room-type.model';

export class AncillaryConfiguration {
    id: number;
    clientId?: number;
    costCenterId: number;
    targetWHPUOS: number;
    variableTargetWHPUOS: number;
    fixedTargetWHPUOS: number;
    unitOfServiceId: number;
    typeOfWorkTemplate: string;
    addOns: boolean;
    hasRoomTypes: boolean;
    modifiedByUserName: string;
    modifiedDate: Date;
    createdDate: Date;
    inactiveDate: Date;
    acuityCategories: AcuityCategory[];
    lastInactivatedAcuityCategories: AcuityCategory[];
    roomTypes: RoomType[];
    enterUOSByBlock: boolean;
    defaultToNoOccupancy: boolean;    
    isAcuityCategoriesOrderUpdated :boolean;
    isRoomsOrderUpdated: boolean;
}
